module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-gray@3x-cba14c99c4ebffb7358d80cfc5fe62af.png";